module.exports = __webpack_public_path__ + "portal-static/img/teachteam_ico_avatar.66c0752e.png";